import{ FC, ReactNode } from 'react';

import * as serviceWorker from 'serviceWorker';
import { ErrorBoundary } from 'config/sentry';
import { UIMessageProvider, NotificationsProvider } from 'modules/ui';
import { MapProvider } from 'modules/map';

import { plugins } from '../config';

import { Fela } from '../modules/fela';
import { Redux } from '../modules/redux';
import { Router } from '../modules/router';

import Enhancers from '../containers/Enhancers';
import TeamDialogProvider from 'modules/teams/components/TeamDialogProvider/TeamDialogProvider';

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
plugins.serviceWorker ? serviceWorker.register({}) : serviceWorker.unregister();

const Core: FC<{ children: ReactNode }> = ({ children }) => {
    return (
        // Render nothing for providers but still provide error to sentry
        <ErrorBoundary fallback={null}>
            <Redux>
                <Fela>
                    <Router>
                        <Enhancers>
                            <UIMessageProvider>
                                <NotificationsProvider>
                                    <TeamDialogProvider>
                                        <MapProvider>{children}</MapProvider>
                                    </TeamDialogProvider>
                                </NotificationsProvider>
                            </UIMessageProvider>
                        </Enhancers>
                    </Router>
                </Fela>
            </Redux>
        </ErrorBoundary>
    );
};

export default Core;
